<template>
  <div class="x-scroll" :style="style">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    padding: {
      default: 10
    }
  },
  data() {
    return {
      
    };
  },
  computed:{
    style(){
      return {
        padding: isNaN(this.padding) ? this.padding : `${this.padding}px`
      }
    }
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
.x-scroll{
  white-space: nowrap;
  overflow-x: scroll;
}
</style>
